<div class="logo">
  <kp-reflect-animation [skipIntro]="skipAnimationIntro"></kp-reflect-animation>
</div>
<div class="product-logo">
  <svg-icon [src]="(themeService.theme$ | async)?.onBackgroundIconUrlWithTag"></svg-icon>
</div>
<ng-container *ngIf="signup; else signIn">
  <h1 *ngIf="isPurposeful" class="main-title">Create your Kumanu Account</h1>
</ng-container>

<ng-template #signIn>
  <h1 class="main-title">Sign in with your Kumanu Account</h1>
</ng-template>
